import { render } from "./ForumList.vue?vue&type=template&id=0b3e7786"
import script from "./ForumList.vue?vue&type=script&lang=js"
export * from "./ForumList.vue?vue&type=script&lang=js"
script.render = render

export default script